<template>
  <div class="marquee" :style="{ backgroundColor: props.bgColor, height: props.height + 'px' }">
    <span
      class="marquee__title"
      ref="marqueeTitle"
      :style="{ color: props.color, fontSize: props.fontSize + 'px', animationDuration: speed + 's', '--speed': speed }"
      v-html="title"
    ></span>
    {{ title }} {{ props.content }}
    <CloseCircleOutlined class="marquee__close" @click="emit('closeScrollNotice')" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";
import { CloseCircleOutlined } from "@ant-design/icons-vue";
const emit = defineEmits(["closeScrollNotice"]);

/**
 * ScrollNoitce 公告栏跑马灯
 * @description 从右往左的跑马灯
 * @property {String} content 显示的内容，支持html
 * @property {String} color 文字颜色，默认#FF7D00
 * @property {Number} fontSize 文字大小，默认14
 * @property {Number} speed 滚动速度，单位s（播放一次所用时间，默认根据内容宽度计算时间）
 * @property {String} bgColor 背景颜色，默认#FFF7E8
 * @property {Number} height 背景高度，默认40
 */
const props = defineProps({
  content: {
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "#FF7D00",
  },
  fontSize: {
    type: Number,
    default: 14,
  },
  speed: {
    type: Number,
    default: 0,
  },
  bgColor: {
    type: String,
    default: "#FFF7E8",
  },
  height: {
    type: Number,
    default: 40,
  },
});
const DEFAULT_SPEED = ref(143);
const title = ref("");
const speed = ref(0);
const marqueeTitle = ref(null);
watch(
  () => props.content,
  (val) => {
    if (val) title.value = val;
    calcSpeed();
  },
  { deep: true }
);
watch(
  () => props.speed,
  (val) => {
    speed.value = val;
  }
);
const calcSpeed = () => {
  if (title.value !== "" && props.speed === 0) {
    let width = (marqueeTitle.value! as Element).clientWidth;
    speed.value = +Number(width / DEFAULT_SPEED.value).toFixed(2);
  }
};
onMounted(() => {
  if (props.content) title.value = props.content;
  if(props.speed) speed.value = props.speed;
  calcSpeed();
});
</script>
<style scoped>
.marquee {
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  word-break: break-all;
  white-space: nowrap;
  overflow: hidden;
}
.marquee__close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.marquee__title {
  cursor: default;
  display: inline-block;
  padding-left: 100%;
  animation: marqueeMove calc(var(--speed) * 1s) linear infinite;
}
.marquee:hover .marquee__title {
  animation-play-state: paused;
}
@keyframes marqueeMove {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}
</style>
